module.exports = __webpack_public_path__ + "img/master-class-icon.530d871a.svg";